"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
require("../../common/style.scss");
var _reportUtil = require("../../utils/reportUtil");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */

const _require = require('@tencent/cms-design-component'),
  Contact = _require.Contact;
const formatContact = (properties, options = {}) => {
  const _properties$modTitle = properties.modTitle,
    modTitle = _properties$modTitle === void 0 ? '' : _properties$modTitle,
    _properties$color = properties.color,
    color = _properties$color === void 0 ? '' : _properties$color,
    _properties$title = properties.title,
    title = _properties$title === void 0 ? '' : _properties$title,
    _properties$content = properties.content,
    content = _properties$content === void 0 ? '' : _properties$content,
    _properties$pcBackgro = properties.pcBackgroundImage,
    pcBackgroundImage = _properties$pcBackgro === void 0 ? '' : _properties$pcBackgro,
    _properties$mbBackgro = properties.mbBackgroundImage,
    mbBackgroundImage = _properties$mbBackgro === void 0 ? '' : _properties$mbBackgro,
    _properties$list = properties.list,
    list = _properties$list === void 0 ? [] : _properties$list;
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains: options === null || options === void 0 ? void 0 : options.domains
    }),
    formatUrlString = _getFormatUrlMethods.formatUrlString,
    formatUrlInText = _getFormatUrlMethods.formatUrlInText;
  const buttonConfig = list.map((item, index) => {
    const _item$txt = item.txt,
      txt = _item$txt === void 0 ? '' : _item$txt,
      _item$href = item.href,
      hrefBase = _item$href === void 0 ? '' : _item$href,
      _item$colType = item.colType,
      colType = _item$colType === void 0 ? 'blue' : _item$colType,
      _item$sizeType = item.sizeType,
      sizeType = _item$sizeType === void 0 ? 'in' : _item$sizeType;
    const href = formatUrlString(hrefBase);
    return {
      txt,
      href,
      colType,
      sizeType,
      alignType: 'center',
      extendProps: {
        'report-event-goal': 'click_contact_us',
        'report-event': 'click_contact_us_button',
        'report-ext1': txt,
        'report-ext2': index,
        'report-ext3': href
      }
    };
  });
  return {
    modTitle,
    title,
    content: formatUrlInText(content),
    pcBackgroundImage,
    mbBackgroundImage,
    buttonConfig,
    color
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatContact = formatContact(data, {
        domains
      }),
      _formatContact$modTit = _formatContact.modTitle,
      modTitle = _formatContact$modTit === void 0 ? '' : _formatContact$modTit,
      _formatContact$title = _formatContact.title,
      title = _formatContact$title === void 0 ? '' : _formatContact$title,
      _formatContact$conten = _formatContact.content,
      content = _formatContact$conten === void 0 ? '' : _formatContact$conten,
      _formatContact$pcBack = _formatContact.pcBackgroundImage,
      pcBackgroundImage = _formatContact$pcBack === void 0 ? '' : _formatContact$pcBack,
      _formatContact$mbBack = _formatContact.mbBackgroundImage,
      mbBackgroundImage = _formatContact$mbBack === void 0 ? '' : _formatContact$mbBack,
      _formatContact$button = _formatContact.buttonConfig,
      buttonConfig = _formatContact$button === void 0 ? [] : _formatContact$button,
      color = _formatContact.color;
    const bgStyle = color ? (0, _componentUtils.doComponentsBgColorEvent)(color) : {}; // 处理组件背景色
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: modTitle
    }, (0, _reportUtil.reportShow)(['show_contact', componentKey, modTitle])), /*#__PURE__*/React.createElement(Contact, {
      style: bgStyle,
      title: title,
      content: content,
      pcBackgroundImage: pcBackgroundImage,
      mbBackgroundImage: mbBackgroundImage,
      buttonConfig: buttonConfig
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}